<template>
  <div class="scroll">
    <div class="top">
      <div class="top_left">
        <img src="../../assets/image/imgHome.png" alt="">
        <div class="ft">{{ showTxt }}，{{ nickname }}
          <div class="copy">{{ showCopy }}</div>
        </div>
      </div>
      <div class="top_right">
        <div class="rightTitle">快捷功能</div>
        <div class="topRightBot">
          <div class="item" v-for="(item, index) in list" :key="index">
            <div class="itemBox" v-if="item.satatus">
              <div class="img_box">
                <img :src="item.logo" :style="'background:' + item.bgcolor" @click="$router.push(item.router)" />
              </div>
              <div class="itemname">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="item" style="width: 45%">
        <div class="item_t">
          <div class="block"></div>
          <span>更新日志</span>
        </div>
        <div class="scoll_view">
          <div class="view_s">
            <div class="step" v-for="(item, index) in vs" :key="index">
              <div class="round">
                <div class="fontS" style="font-size: 14px">{{ item.ts[1] }}月</div>
                <div class="fontS" style="font-size: 16px">{{ item.ts[2] }}</div>
                <div class="fontS" style="font-size: 14px">{{ item.ts[0] }}</div>
              </div>
              <div class="line"></div>
              <div class="vs">{{ item.version }}</div>
              <div class="min_s" v-for="(ls, idx) in item.features" :key="idx">
                <div class="min_t">{{ ls.title }}</div>
                <div class="min_m" v-for="(ms, i) in ls.items.split('<br />')" :key="i">{{ ms }}</div>
              </div>
            </div>
          </div>
          <div class="more2">
            <div class="ron"></div>
            <div @click="morelog">查看更多</div>
          </div>
        </div>
      </div>
      <div class="item" style="width: calc(55% - 15px)">
        <div class="item_t">
          <div class="block"></div>
          <span>帮助中心</span>
        </div>
        <div class="scoll_view">
          <div class="view_s">
            <div class="view_item" v-for="(item, index) in answer" :key="index">
              <div class="view">
                <div class="min fontWeight">问：</div>
                <div class="item_v fontWeight">{{ item.question }}</div>
              </div>
              <div class="view">
                <div class="min">答：</div>
                <div class="item_v">
                  {{ item.answer }}
                </div>
              </div>
            </div>
          </div>
          <div class="more" @click="more_is">查看更多</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { checkPermission } from '@/utils/permissions'
import {
  get_list_faq,
  //  get_list_update,
  versionList
} from '@/api/system'
import { timeFix } from '@/utils/util'
import { mapState } from 'vuex'
import { PageHeaderWrapper } from '@ant-design-vue/pro-layout'
import { getRoleList, getServiceList } from '@/api/manage'
import { Radar } from '@/components'
import {
  mapActions,
  mapGetters
} from 'vuex'
const DataSet = require('../../utils/data-set.min.js')

export default {
  name: 'Welcome',
  components: {
    PageHeaderWrapper,
    Radar,
  },
  data() {
    return {
      list: [
        {
          name: '我的申请',
          bgcolor: '#F76B1C',
          logo: require('../../../public/images/apply.png'),
          router: '/settings/businessList',
          satatus: true,
        },
        {
          name: '我的待办',
          bgcolor: '#F76B1C',
          logo: require('../../../public/images/tasking.png'),
          router: '/settings/Tasking',
          satatus: true,
        },
        {
          name: '抄送我的',
          bgcolor: '#F76B1C',
          logo: require('../../../public/images/copy.png'),
          router: '/settings/copy',
          satatus: true,
        },
        {
          name: '耗材领用',
          bgcolor: '#6a6fff',
          logo: require('../../../public/images/requisitionIcon.png'),
          router: '/assetmenag/Ex/Requisition',
          satatus: true,
        },
        {
          name: '耗材入库',
          bgcolor: '#6a6fff',
          logo: require('../../../public/images/direct.png'),
          router: '/assetmenag/Wa/Direct',
          satatus: checkPermission('assetmenag:wa:direct'),
        },
        {
          name: '库存查询',
          bgcolor: '#2b84f9',
          logo: require('../../../public/images/financial.png'),
          router: '/assetmenag/financial',
          satatus: true,
        },
        {
          name: '耗材出库',
          bgcolor: '#6c75ff',
          logo: require('../../../public/images/delivery.png'),
          router: '/assetmenag/Ex/delivery',
          satatus: true,
        },
        {
          name: '资产查询',
          bgcolor: '#2483FF',
          logo: require('../../../public/images/consumables.png'),
          router: '/assetmenag/consumables',
          satatus: true,
        },
        {
          name: '耗材申购',
          bgcolor: '#6c75ff',
          logo: require('../../../public/images/requisition.png'),
          router: '/purchase/requisition',
          satatus: true,
        },
        {
          name: '资产申购',
          bgcolor: '#2483FF',
          logo: require('../../../public/images/applyIcon.png'),
          router: '/purchase/apply',
          satatus: true,
        },
        {
          name: '采购验收',
          bgcolor: '#6c75ff',
          logo: require('../../../public/images/transfer.png'),
          router: '/purchase/acceptance',
          satatus: true,
        },
        {
          name: '确认移交',
          bgcolor: '#2b84f9',
          logo: require('../../../public/images/transferIcon.png'),
          router: '/purchase/transfer',
          satatus: true,
        },
        {
          name: '采购查询',
          bgcolor: '#2b84f9',
          logo: require('../../../public/images/purchaseinquire.png'),
          router: '/purchase/purchaseinquire',
          satatus: true,
        },
        // {
        //   name: '付款申请',
        //   bgcolor: '#0fb7b8',
        //   logo: require('../../../public/images/payapplication.png'),
        //   router:'/financial/payapplication',
        //   satatus: true,
        // },
        //  {
        //   name: '报销申请',
        //   bgcolor: '#0fb7b8',
        //   logo: require('../../../public/images/reimbursement.png'),
        //   router:'/financial/reimbursement',
        //   satatus: true,
        // },
        {
          name: '更多功能',
          bgcolor: '#F76B1C',
          logo: require('../../../public/images/more.png'),
          router: '/dashboard/shortcuts',
          satatus: true,
        },
      ],
      timeFix: timeFix(),
      avatar: '',
      user: {},
      projects: [],
      username: '',
      loading: true,
      radarLoading: true,
      activities: [],
      teams: [],
      // data
      axis1Opts: {
        dataKey: 'item',
        line: null,
        tickLine: null,
        grid: {
          lineStyle: {
            lineDash: null,
          },
          hideFirstLine: false,
        },
      },
      axis2Opts: {
        dataKey: 'score',
        line: null,
        tickLine: null,
        grid: {
          type: 'polygon',
          lineStyle: {
            lineDash: null,
          },
        },
      },
      scale: [
        {
          dataKey: 'score',
          min: 0,
          max: 80,
        },
      ],
      axisData: [
        {
          item: '引用',
          a: 70,
          b: 30,
          c: 40,
        },
        {
          item: '口碑',
          a: 60,
          b: 70,
          c: 40,
        },
        {
          item: '产量',
          a: 50,
          b: 60,
          c: 40,
        },
        {
          item: '贡献',
          a: 40,
          b: 50,
          c: 40,
        },
        {
          item: '热度',
          a: 60,
          b: 70,
          c: 40,
        },
        {
          item: '引用',
          a: 70,
          b: 50,
          c: 40,
        },
      ],
      changeList: [
        {
          title: '1.1.0-SNAPSHOT 2020-03-12',
          color: 'green',
          list: [
            '根据流程文件部署流程定义',
            'fix:用户管理调用所有部门接口',
            '工作流程追踪高亮连线',
            '工作流高亮已执行环节',
            '增加工作流activiti支持',
            'fix:更新path等为空时无效',
            'menu增加路径、重定向、隐藏等字段',
            '增加捐赠内容板块',
            'fix:代码生成调优',
            'fix: gen bugs gitee !9',
            '动态菜单优化',
          ],
        },
        {
          title: '1.0.2-SNAPSHOT 2019-09-30',
          color: 'green',
          list: [
            '优化角色授权实现联动和半选',
            '用户管理增加部门检索功能',
            '代码生成增加树形模板',
            '代码生成模板适配vue',
            '分布式文件系统',
            '修复代码生成前缀无法自动去除',
            '操作日志增加请求方法',
            '移除jwt依赖',
            'swagger接口文档支持',
            '前端i18n国际化支持',
            '增加vue代码生成（部分）',
            'vue-cropper头像组件',
          ],
        },
        {
          title: '1.0.1-SNAPSHOT 2019-08-23',
          color: 'green',
          list: [
            '新增ruoyi 4.0代码生成功能，未修改模板',
            '修复数据权限导致不能分页的bug',
            '增加oss文件上传',
            '增加参数配置管理',
            '升级spring-alibaba-cloud版本到2.1.x',
            '优化读写分离逻辑',
          ],
        },
        {
          title: '1.0.0-SNAPSHOT 2019-07-25',
          color: 'green',
          list: [
            'maven坐标修改为com.ruoyi.cloud',
            '升级springboot版本到2.1.6',
            '升级springcloud版本到Greenwich.SR2',
            '用户管理部门不应该选中父节点',
            '菜单授权联动bug（受限于ant-design）,取消父子联动',
            '数据权限',
            '移除多余的依赖声明',
            '增加vue代码生成（部分）',
            '修复登陆记录调取token的bug',
          ],
        },
      ],
      radarData: [],
      answer: [], //常见问题
      vs: [], //版本,
      showTxt: ''
    }
  },
  computed: {
    ...mapGetters(['nickname', 'avatar']),
    currentUser() {
      return {
        name: '若依',
        avatar: 'https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png',
      }
    },
    userInfo() {
      return this.$store.getters.userInfo
    },
  },
  created() {
    console.log()
    let index = Math.floor(Math.random() * this.phrases.length)
    this.showCopy = this.phrases[index]
    console.log(index)
    // 获取当前时间
    let timeNow = new Date();
    // 获取当前小时
    let hours =timeNow.getHours();
    console.log(hours)
    // 判断当前时间段
    if (hours >= 0 && hours <= 4) {
      this.showTxt = `凌晨好`;
    } else if (hours > 4 && hours <= 7) {
      this.showTxt = `早上好`;
    } else if (hours > 7 && hours <= 11) {
      this.showTxt = `上午好`;
    } else if (hours > 11 && hours <= 12) {
      this.showTxt = `中午好`;
    } else if (hours > 12 && hours <= 16) {
      this.showTxt = `下午好`;
    } else if (hours > 16 && hours <= 17) {
      this.showTxt = `傍晚好`;
    } else if (hours > 17 && hours <= 21) {
      this.showTxt = `晚上好`;
    } else if (hours > 21 && hours <= 24) {
      this.showTxt = `夜深了`;
    }
    this.user = this.userInfo
    this.avatar = this.userInfo.avatar
    getRoleList().then((res) => {
      // console.log('workplace -> call getRoleList()', res)
    })
    // getServiceList().then((res) => {
    //   console.log('workplace -> call getServiceList()', res)
    // })
    versionList({
      type: 1
    }).then((res) => {
      res.data.forEach(item => {

        Object.assign(item, {
          features: [],
          ts: []
        })
        res.data.forEach((item) => {
          item.ts = item.date.split('-')
        })
        item.features.push(
          {
            items: item.items,
            title: item.title
          }
        )
        item.features[0].items = item.features[0].items.replace(/\n/g, '<br />');
      })
      this.vs = res.data
      console.log(this.vs, ' this.vs======================')
    })
    // get_list_update({ max: 2 }).then((res) => {
    //   var lis = res.data
    //   lis.forEach((element) => {
    //     element['ts'] = element.date.split('-')
    //   })
    //     this.vs = res.data
    //     console.log(this.vs, 'this.vs======================')
    //   })
    // get_list_update({ max: 2 }).then((res) => {
    //   var lis = res.data
    //   lis.forEach((element) => {
    //     element['ts'] = element.date.split('-')
    //   })
    //   this.vs = res.data
    // })
    get_list_faq().then((res) => {
      this.answer = res.data[0].list
    })
  },
  mounted() {
    this.getTeams()
    this.initRadar()
    this.username = this.$store.getters.userInfo.userName
  },
  methods: {
    more_is() {
      let routeUrl = this.$router.resolve({
        path: '/moreissue',
        query: { id: 96 },
      })
      window.open(routeUrl.href, '_blank')
    },
    morelog() {
      let routeUrl = this.$router.resolve({
        path: '/logs',
        query: { id: 96 },
      })
      window.open(routeUrl.href, '_blank')
    },
    getTeams() {
      this.$http.get('/workplace/teams').then((res) => {
        this.teams = res.result
        this.loading = false
      })
    },
    initRadar() {
      this.radarLoading = true
      this.$http.get('/workplace/radar').then((res) => {
        const dv = new DataSet.View().source(res.result)
        dv.transform({
          type: 'fold',
          fields: ['个人', '团队', '部门'],
          key: 'user',
          value: 'score',
        })

        this.radarData = dv.rows
        this.radarLoading = false
      })
    },
  },
}
</script>

<style lang="less" scoped>
.scroll {
  width: 100%;
  height: 100%;
  float: left;
  padding: 10px;
  box-sizing: border-box;

  .top {
    width: 100%;
    height: 42%;
    float: left;

    .top_left {
      width: 45%;
      height: 100%;
      float: left;
      background: #fff;
      position: relative;
      border-radius: 10px;
      overflow: hidden;

      img {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 0
      }

      .ft {
        z-index: 1;
        position: relative;
        font-size: 22px;
        color: #1890FF;
        font-weight: 600;
        text-shadow: 1px 1px 1px #4e6c9d;
        height: 100%;
        padding: 30px 20px 20px 20px;

        .copy {
          font-size: 13px;
          font-weight: normal;
          color: #333;
          width: 75%;
          margin-top: 10px;
        }
      }
    }

    .top_right {
      width: calc(55% - 15px);
      float: right;
      height: 100%;
      background: #fff;
      border-radius: 10px;
      overflow: hidden;
      padding: 0 15px;
      box-sizing: border-box;

      .rightTitle {
        width: 100%;
        height: 45px;
        float: left;
        line-height: 45px;
        border-bottom: 1px solid #ddd;
        font-size: 16px;
        box-sizing: border-box;
        color: #2479e2;
        font-weight: 600;
      }

      .topRightBot {
        width: 100%;
        height: calc(100% - 45px);
        float: left;
        box-sizing: border-box;

        .item {
          width: 14%;
          float: left;
          

          .itemBox {
            width: 100%;
            float: left;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-top: 15px;
            .img_box {
              width: 100%;
              float: left;

              display: flex;
              justify-content: center;
              align-items: center;

              img {
                width: 55%;
                padding: 10px;
                border-radius: 12px;
                cursor: pointer;
              }
            }
            .itemname{
              width: 100%;
              text-align: center;
              margin-top: 3px;
            }
          }
        }
      }

    }
  }

  .bottom {
    width: 100%;
    height: calc(58% - 10px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    float: left;
    overflow: hidden;

    .item {
      padding: 0 15px;
      box-sizing: border-box;
      float: left;
      background: #fff;
      border-radius: 10px;
      height: 100%;

      .item_t {
        width: 100%;
        float: left;
        height: 35px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-bottom: 1px solid #ddd;
        box-sizing: border-box;

        .block {
          width: 3px;
          height: 17px;
          background: #2479e2;
          margin-right: 15px;
        }

        span {
          font-size: 14px;
          font-weight: 600;
          color: #2479e2;
        }
      }

      .scoll_view {
        width: 100%;
        float: left;
        padding-left: 20px;
        box-sizing: border-box;
        height: calc(100% - 35px);
        font-family: '微软雅黑' !important;
        overflow-y: scroll;
        font-family: emoji;

        &::-webkit-scrollbar {
          display: none;
        }

        .view_s {
          width: 100%;
          float: left;
          padding: 10px 0;
          box-sizing: border-box;
          overflow: hidden;

          .view_item {
            width: 100%;
            float: left;
            margin-bottom: 8px;

            .view {
              width: 100%;
              float: left;
              margin-bottom: 8px;
              font-size: 16px;

              .min {
                width: 30px;
                float: left;
              }

              .item_v {
                width: calc(100% - 30px);
                float: left;
              }
            }
          }

          .step {
            width: 100%;
            float: left;
            padding-left: 135px;
            box-sizing: border-box;
            position: relative;

            .line {
              width: 3px;
              height: 100%;
              background: #2cb1ff;
              float: left;
              position: absolute;
              left: 50px;
            }

            .round {
              position: absolute;
              width: 70px;
              height: 70px;
              border-radius: 50%;
              overflow: hidden;
              background: #2cb1ff;
              left: 15px;
              top: 0;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              color: #fff;
              z-index: 2;

              .fontS {
                line-height: 20px;
              }
            }

            .vs {
              width: 100%;
              font-size: 18px;
              font-weight: 600;
            }

            .min_s {
              width: 100%;
              float: left;
              padding-bottom: 13px;
              min-height: 100px;

              .min_t {
                width: 100%;
                float: left;
                color: #111;
                font-weight: 600;
                font-size: 16px;
              }

              .min_m {
                width: 100%;
                float: left;
                margin-top: 4px;
              }
            }
          }
        }

        .more {
          width: 100%;
          height: 30px;
          float: left;
          cursor: pointer;
          color: #2cb1ff;
          font-weight: 600;
        }

        .more2 {
          width: 100%;
          height: 30px;
          float: left;
          cursor: pointer;
          color: #2cb1ff;
          font-weight: 600;
          padding-left: 38px;
          box-sizing: border-box;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .ron {
            width: 26px;
            height: 26px;
            border-radius: 50%;
            background: #2cb1ff;
            margin-right: 13px;
          }
        }
      }
    }
  }
}
.fontWeight{
  font-weight: 600;
}
</style>
